import { type PropsWithChildren, type ReactElement } from 'react'
import * as S from './error-component.styled'

export default function ErrorComponent ({ children }: PropsWithChildren): ReactElement {
  return <S.Error>{children}</S.Error>
}
